// pages/SettingsPage.js
import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const SettingsPage = () => {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ marginLeft: '240px', width: '100%' }}>
        <Navbar />
        <div style={{ padding: '20px' }}>
          <h2>Settings</h2>
          <p>Adjust settings here.</p>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
